var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section", attrs: { id: "shipping-instructions" } },
    [
      _c(
        "div",
        {
          staticClass:
            "flex is-flex-direction-row is-justify-content-flex-end mb-3",
        },
        [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c("b-button", { on: { click: _vm.HandleMultipleCreation } }, [
                _vm._v(" Create PO "),
              ]),
              _c(
                "b-button",
                { attrs: { type: "is-info" }, on: { click: _vm.onRuningJob } },
                [_vm._v(" Run job ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-alpine",
        staticStyle: { width: "100%", height: "700px" },
        attrs: {
          "row-data": _vm.formattedShippingInstructions,
          "grid-options": _vm.gridOptions,
          "get-context-menu-items": _vm.getContextMenuItems,
          pagination: true,
          "animate-rows": true,
          "pagination-auto-page-size": true,
          "side-bar": ["columns"],
          "multi-sort-key": "ctrl",
          modules: _vm.modules,
        },
        on: { "grid-ready": _vm.gridReady },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            scroll: "keep",
            "has-modal-card": "",
            active: _vm.creating.isOpened,
          },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.creating, "isOpened", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-card" },
            [
              _c("SiForm", {
                attrs: { si: _vm.editingSi },
                on: { submit: _vm.editShippingInstruction },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: { scroll: "keep", active: _vm.isDetailView },
          on: {
            "update:active": function ($event) {
              _vm.isDetailView = $event
            },
          },
        },
        [_c("DetailModal", { attrs: { si: _vm.selectedSiNumber } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }